import { render } from "./ModulesListItem.vue?vue&type=template&id=0da605b2&scoped=true"
import script from "./ModulesListItem.vue?vue&type=script&lang=js"
export * from "./ModulesListItem.vue?vue&type=script&lang=js"

import "./ModulesListItem.vue?vue&type=style&index=0&id=0da605b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da605b2"]])

export default __exports__